import { OktaAuth } from "@okta/okta-auth-js";
import { APP_CONFIG } from "./authConfig";

export const oktaAuth = new OktaAuth({
  issuer: APP_CONFIG.issuer,
  clientId: APP_CONFIG.clientId,
  redirectUri: APP_CONFIG.redirectUri,

  scopes: APP_CONFIG.scopes,

  pkce: true,

  tokenManager: {
    storage: "sessionStorage"
  }
});